import React from 'react';

export const MissedCallIcon = ({ width = 20, height = 20, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_43123_23286)">
      <path
        d="M2 9.33301V5.33301H6"
        stroke="#B91C1C"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 5.33301L8 11.333L14 5.33301"
        stroke="#B91C1C"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_43123_23286">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
